import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-133" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-134" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-135" data-mp="2wmyegiul7n80">Ti riconosci in queste situazioni?</h2>
        <p className="mt-4 text-brand-gray" data-id="element-136" data-mp="2rsayx9hka35k">
          Se anche solo una di queste ti suona familiare, Matematica Pronta è fatto per te.
        </p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-137" data-mp="30ple35xi2cfr">
          {painPoints.map(({
          icon: PointIcon,
          text
        }) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-5 text-left shadow-sm" data-id="element-138" data-mp="3fhlt284eozaq">
              <PointIcon className="h-6 w-6 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-139" data-mp="3oggy3gvps3cg" />
              <span className="text-sm font-semibold leading-snug" data-id="element-140" data-mp="3kg6vme74rv2c">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-serif text-2xl font-bold italic text-brand-purple" data-id="element-141" data-mp="sx4dpglsayk8">
          E tu meriti molto più di questo.
        </p>
      </Reveal>
    </section>;
}